import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const BASE_URL = environment.base_url_second;

@Injectable({
    providedIn: 'root'
})
export class FormResponseService {

    constructor(private http: HttpClient) { }

    submitFormResponse(formResponse: any) {
        const url = `${BASE_URL}/formResponse`;
        return this.http.post(url, formResponse);
    }

    getAllFormResponse(formId: string) {
        const url = `${BASE_URL}/formResponse?formId=${formId}`;
        return this.http.get(url);
    }

    getOneByFormId(formId: string) {
        const url = `${BASE_URL}/formResponse/${formId}`;
        return this.http.get(url);
    }

    updateFormResponse(formResponse: any) {
        const url = `${BASE_URL}/formResponse`;
        return this.http.put(url, formResponse);
    }
}